import getElementSettings from '../accessors/get-element-settings';

const isElementMatchSettings = (element) => {
  const settings = getElementSettings();

  return settings.some((setting) => setting.matches(element, setting.settings));
};

export default isElementMatchSettings;
